{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome paplašinājums nav instalēts.",
      "CTA": "Instalēt paplašinājumu"
    },
    "TABS": {
      "PHONE": "Tālrunis",
      "SMS": "SMS",
      "HISTORY": "Vēsture"
    },
    "HISTORY": {
      "OPEN": "Atvērt",
      "RECENT": "Nesenie",
      "MISSED": "Neatbildēti",
      "LOADING": "Ielādē zvanus...",
      "EMPTY": "Šeit nav zvanu",
      "ERROR": "Neizdevās ielādēt zvanus",
      "CALL": "Pārzvanīt",
      "CALL_STATUS": {
        "BUTTON": "Iestatīt zvana statusu",
        "TITLE": "Zvana statuss",
        "SEARCH_PLACEHOLDER": "Meklēt statusus...",
        "LOADING": "Ielādē statusus...",
        "NO_OPTIONS": "Nav konfigurētu zvana statusu",
        "NO_MATCH": "Neviens statuss neatbilst",
        "OPTIONS_ERROR": "Neizdevās ielādēt statusus",
        "RETRY": "Mēģināt vēlreiz",
        "CONFIRM_QUESTION": "Vai tiešām vēlaties iestatīt statusu “{status}” un atrisināt sarunu?",
        "CONFIRM": "Apstiprināt",
        "BACK": "Atpakaļ",
        "CANCEL": "Atcelt",
        "SAVING": "Notiek saglabāšana...",
        "SAVE_ERROR": "Neizdevās saglabāt statusu",
        "RESOLVE_ERROR": "Statuss saglabāts, bet sarunu neizdevās atrisināt"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Tālruņa numurs, piem., +421903000000",
      "BODY_PLACEHOLDER": "Ierakstiet savu ziņojumu...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Sūtīt SMS",
      "SENDING": "Notiek sūtīšana...",
      "SENT": "SMS nosūtīts",
      "LOADING": "Notiek SMS iesūtņu ielāde...",
      "NO_INBOX": "Šim kontam nav SMS iesūtnes, tāpēc SMS nevar nosūtīt.",
      "INVALID_NUMBER": "Ievadiet numuru starptautiskā formātā, ieskaitot + sākumā.",
      "ERROR": "SMS neizdevās nosūtīt. Lūdzu, mēģiniet vēlreiz."
    },
    "ACTIONS": {
      "CONNECT": "Savienot",
      "GO_TO_TAB": "Pāriet uz šo cilni",
      "DISCONNECT": "Atvienot",
      "ANSWER": "Atbildēt",
      "HANGUP": "Beigt zvanu",
      "HOLD": "Aizturēt",
      "MUTE": "Apklusināt mikrofonu",
      "SILENCE": "Apklusināt skaņu",
      "TRANSFER": "Pārvienot",
      "COMPLETE_TRANSFER": "Pabeigt pārvienošanu",
      "RETURN_TO_CALLER": "Atgriezties pie zvanītāja",
      "CANCEL_TRANSFER": "Atcelt pārvienošanu",
      "DIALPAD": "Rādīt ciparu tastatūru",
      "OPEN_CONVERSATION": "Atvērt sarunu"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Ienākošs zvans",
      "INCOMING_CALL_FROM": "Ienākošs zvans no {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Ienākošs zvans no {number}",
      "ANSWER": "Atbildēt",
      "DECLINE": "Noraidīt"
    },
    "TRANSFER": {
      "TITLE": "Zvana pārvienošana",
      "PLACEHOLDER": "Ievadiet pārvienošanas numuru...",
      "SEARCH_PLACEHOLDER": "Meklēt aģentus...",
      "TARGET_PLACEHOLDER": "Izvēlētais pārvienošanas mērķis",
      "CONFIRM": "Pārvienot",
      "MODE_DIRECT": "Pārvienot tagad",
      "MODE_CONSULT": "Vispirms zvanīt aģentam",
      "CANCEL": "Atcelt"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Vai tiešām vēlaties doties pārtraukumā visās rindās?",
      "CONFIRM_READY": "Vai tiešām vēlaties atgriezties gatavības statusā visās rindās?",
      "CONFIRM_BREAK_QUEUE": "Vai tiešām vēlaties izrakstīties no rindas {queue}?",
      "CONFIRM_READY_QUEUE": "Vai tiešām vēlaties pierakstīties rindā {queue}?",
      "LOGIN_TO_QUEUE": "Pierakstīties",
      "LOGOUT_FROM_QUEUE": "Izrakstīties",
      "LOGIN_TO_ALL_QUEUES": "Pierakstīties visās rindās",
      "LOGOUT_FROM_ALL_QUEUES": "Izrakstīties no visām rindām",
      "OPTION_LOGOUT": "Izrakstīties",
      "OPTION_BREAK": "Pārtraukums",
      "OPTION_LUNCH": "Pusdienas",
      "OPTION_AWAY": "Prom",
      "OPTION_DO_NOT_DISTURB": "Netraucēt",
      "OPTION_BUSINESS_TRIP": "Komandējums",
      "CONFIRM": "Apstiprināt",
      "CANCEL": "Atcelt"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Nav savienojuma ar tālruņa sistēmu",
      "MESSAGE": "Šķiet, ka jūsu interneta savienojums ir zudis. Pārbaudiet to un mēģiniet vēlreiz.",
      "CREDENTIALS_TITLE": "Tālruņa sistēma noraidīja jūsu akreditācijas datus",
      "CREDENTIALS_MESSAGE": "Tālruņa sistēma noraidīja jūsu profilā saglabāto lietotājvārdu vai paroli. Pārbaudiet tos sadaļā Profila Iestatījumi, vai sazinieties ar savu administratoru.",
      "CONFIGURATION_TITLE": "Tālruņa iestatījumi nav derīgi",
      "CONFIGURATION_MESSAGE": "SIP lietotājvārds vai servera adrese nav derīgā formātā, tāpēc tālrunis nevar izveidot savienojumu. Labojiet to sadaļā Profila Iestatījumi.",
      "NETWORK_SHORT": "Savienojums neizdevās",
      "CREDENTIALS_SHORT": "Akreditācijas dati noraidīti",
      "CONFIGURATION_SHORT": "Nederīgi tālruņa iestatījumi",
      "RETRY": "Mēģināt vēlreiz",
      "DISMISS": "Atcelt"
    },
    "CONNECTION_QUALITY": "Savienojuma kvalitāte",
    "CONNECTION_QUALITY_EXCELLENT": "Izcila",
    "CONNECTION_QUALITY_GOOD": "Laba",
    "CONNECTION_QUALITY_FAIR": "Vidēja",
    "CONNECTION_QUALITY_POOR": "Slikta",
    "CONNECTION_QUALITY_DISCONNECTED": "Atvienots",
    "STATUS": {
      "OFFLINE": "Tālrunis bezsaistē",
      "IN_OTHER_TAB": "Tālrunis pievienots citā cilnē",
      "CONNECTING": "Notiek savienošana...",
      "DISCONNECTING": "Notiek atvienošana...",
      "ONLINE": "Tālrunis tiešsaistē",
      "DIALING": "Zvana",
      "TRANSFERRING": "Notiek pārvienošana...",
      "CONSULTING": "Runā ar aģentu",
      "CALLER_ON_HOLD": "Zvanītājs gaida",
      "BUSY": "Aizņemts",
      "DND": "DND",
      "UNAVAILABLE": "Nav pieejams",
      "REJECTED": "Zvans noraidīts",
      "CALL_FAILED": "Zvans neizdevās"
    },
    "QUEUES": {
      "MORE": "Citas rindas"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Zvana {number}… Šo cilni var aizvērt.",
    "NO_NUMBER": "Nav norādīts numurs. Izmantojiet ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Ievadiet tālruņa numuru...",
    "ACTIONS": {
      "DIAL": "Zvanīt",
      "DIAL_FROM": "Izvēlieties numuru, no kura zvanāt"
    },
    "DIAL_FROM": {
      "TITLE": "Zvanīt no iesūtnes numura"
    },
    "VALIDATION": {
      "REQUIRED": "Tālruņa numurs ir obligāts",
      "INVALID_FORMAT": "Nederīgs tālruņa numura formāts"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Audio iestatījumi un testēšana",
    "SELECT_DEVICE": "Izvēlieties ierīci...",
    "SYSTEM_DEFAULT": "Sistēmas noklusējums",
    "SAVED": "Saglabāts",
    "DISCONNECTED_SUFFIX": "nav pievienota",
    "DEVICE_DISCONNECTED": "Izvēlētā ierīce nav pievienota. Zvani izmanto sistēmas noklusējuma ierīci, līdz tā ir atkal pieejama.",
    "MICROPHONE": {
      "TITLE": "Mikrofons",
      "START_TEST": "Testēt mikrofonu",
      "STOP_TEST": "Apturēt testu",
      "LEVEL": "Līmenis:",
      "VERDICT": {
        "LISTENING": "Pasakiet kaut ko mikrofonā…",
        "SILENT": "Jūs nav dzirdams. Pārbaudiet, vai mikrofons ir ieslēgts un izvēlēts pareizais.",
        "LOW": "Jūs ir dzirdams tikai klusi. Izvēlieties citu mikrofonu vai pielāgojiet ievades skaļumu sistēmas iestatījumos.",
        "GOOD": "Laba skaņas kvalitāte — jūs ir labi dzirdams."
      }
    },
    "SPEAKER": {
      "TITLE": "Skaļrunis",
      "TEST": "Testēt skaļruni",
      "TESTING": "Notiek testēšana...",
      "VOLUME": "Skaļums:",
      "USING_DEFAULT": "Izvēlētā izvades ierīce nav pieejama — atskaņots caur sistēmas noklusējuma ierīci."
    },
    "DONE": "Gatavs",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Kļūda, piekļūstot mikrofonam. Lūdzu, pārbaudiet atļaujas.",
      "MICROPHONE_PERMISSION_DENIED": "Piekļuve mikrofonam ir bloķēta. Atļaujiet to pārlūkprogrammas vietnes iestatījumos, lai izmantotu tālruni.",
      "MICROPHONE_SILENT": "Jūsu mikrofons neuztver nekādu skaņu. Pārbaudiet audio iestatījumus.",
      "EXTENSION_REQUIRED": "Tālruņa paplašinājums nav atrasts. Lūdzu, instalējiet vai iespējojiet to, lai izmantotu mikrofonu.",
      "SPEAKER_TEST": "Kļūda, testējot skaļruņa izvadi."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Bezsaistē",
    "ONLINE": "Tiešsaistē",
    "BUSY": "Aizņemts"
  },
  "QUEUE_STATUS": {
    "READY": "Gatavs",
    "NOT_READY": "Nepieņem zvanus",
    "WRAP_UP": "Pēcapstrāde",
    "BREAK": "Pārtraukums",
    "LUNCH": "Pusdienas",
    "AWAY": "Prom",
    "DO_NOT_DISTURB": "Netraucēt",
    "BUSINESS_TRIP": "Komandējums",
    "OTHER_CALL": "Cits zvans",
    "QUEUE_CALL": "Rindas zvans",
    "OFFLINE": "Bezsaistē",
    "ONLINE": "Tiešsaistē",
    "NO_ACCESS": "Nav tālruņa",
    "PARTIALLY_READY": "Daļēji gatavs",
    "MIXED": "Jaukts",
    "CHAT_ONLINE": "Tiešsaistē (tērzēšana)",
    "CHAT_BUSY": "Aizņemts (tērzēšana)",
    "CHAT_OFFLINE": "Bezsaistē (tērzēšana)"
  }
}
